var chunkToChildrenMap = {
	"common_src_components_primitives_richtext_formats_bold_js-common_src_components_primitives_ri-973ed2": [
		"webpack_container_remote_kfplatform_filePickerV2",
		"webpack_container_remote_kfplatform_filePreview"
	],
	"src_layouts_flowcontainer_index_jsx": [
		"webpack_container_remote_kfplatform_filePickerV2",
		"webpack_container_remote_kfplatform_filePreview"
	],
	"src_layouts_settingspage_index_jsx": [
		"webpack_container_remote_kfplatform_filePickerV2",
		"webpack_container_remote_kfplatform_filePreview"
	],
	"src_layouts_flow_nav_index_jsx": [
		"webpack_container_remote_kfplatform_filePickerV2",
		"webpack_container_remote_kfplatform_filePreview"
	],
	"src_inputs_datetime_index_jsx": [
		"webpack_container_remote_kfplatform_filePickerV2",
		"webpack_container_remote_kfplatform_filePreview"
	],
	"src_layouts_sharesettings_index_jsx": [
		"webpack_container_remote_kfplatform_filePickerV2",
		"webpack_container_remote_kfplatform_filePreview"
	],
	"src_feedback_tour_index_jsx-webpack_sharing_consume_default_prop-types_prop-types-webpack_sha-d6ca44": [
		"webpack_container_remote_kfplatform_filePickerV2",
		"webpack_container_remote_kfplatform_filePreview"
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };